export default "__VITE_ASSET__Gqaqs8jF__"